import { render, staticRenderFns } from "./Criticite.vue?vue&type=template&id=27dc5946"
import script from "./Criticite.vue?vue&type=script&lang=js"
export * from "./Criticite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports